import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import MetaTags from "./index";
import { defaultMetatags } from "@/lib/constants";
import config from "@/lib/config";
import routes from "@/lib/routes";
import { jsx as _jsx } from "react/jsx-runtime";
export function tags(episode) {
  var _episode$meta_keyword, _episode$genres;
  const keywords = episode !== null && episode !== void 0 && episode.meta_keywords && (episode === null || episode === void 0 || (_episode$meta_keyword = episode.meta_keywords) === null || _episode$meta_keyword === void 0 ? void 0 : _episode$meta_keyword.length) > 0 ? episode.meta_keywords.join(",") : null;
  const genre = (episode === null || episode === void 0 || (_episode$genres = episode.genres) === null || _episode$genres === void 0 || (_episode$genres = _episode$genres[0]) === null || _episode$genres === void 0 ? void 0 : _episode$genres.name) || "";
  return {
    title: `${episode.name}【${genre}】の動画配信 | SPOOX(スプークス)`,
    keywords: keywords || defaultMetatags.vod.keywords,
    description: `${episode.name}の再生画面。SPOOX(スプークス)では、スポーツや映画やアニメ、音楽ライブなど、様々な動画を配信中！月額見放題でも、1作品から購入でも楽しめます。
`,
    og: {
      type: "video.episode",
      url: `${config.host.vod}${routes.watch(episode.id)}`
    },
    twitter: {
      card: "summary"
    }
  };
}
export default function WatchMetaTags(_ref) {
  let {
    episode
  } = _ref;
  const props = tags(episode);
  return /*#__PURE__*/_jsx(MetaTags, _objectSpread({}, props));
}